<app-title-pages-component [pageData]="pageData"></app-title-pages-component>
<div class="container">
  <form [formGroup]="formUser" (ngSubmit)="onSubmit()" autocomplete="off" novalidate>
    <!-- Nombres -->
    <div class="form-row">
      <div class="input-container">
        <input id="firstName" type="text" class="form-control" formControlName="firstName" required
          [ngClass]="{ filled: formUser.get('firstName')?.value }" />
        <label for="firstName">{{ userContent()?.nameLabel }}</label>

        @if (firstName?.invalid && (!firstName?.untouched || firstName?.dirty ||
        submitted)) {
        <div class="alert alert-danger">
          @if (firstName?.hasError('required') ||
          firstName?.hasError('soloEspacios')) {
          <span> {{userContent()?.nameError}}</span>
          }
        </div>
        }
      </div>
      <!-- Apellidos -->
      <div class="input-container">
        <input id="lastName" type="text" class="form-control" formControlName="lastName" required
          [ngClass]="{ filled: formUser.get('lastName')?.value }" />
        <label for="lastName">{{ userContent()?.lastNameLabel }}</label>

        @if (lastName?.invalid && (!lastName?.untouched || lastName?.dirty ||
        submitted)) {
        <div class="alert alert-danger">
          @if (lastName?.hasError('required') ||
          lastName?.hasError('soloEspacios')) {
          <span> {{userContent()?.lastNameError}}</span>
          }
        </div>
        }
      </div>
    </div>
    <!-- Nombre de usuario  -->
    <div class="form-row">
      <div class="input-container">
        <input id="username" type="text" class="form-control" formControlName="username" required
          [ngClass]="{ 
            filled: formUser.get('username')?.value,
            readOnlyInput: id
          }"
          [readonly]="id"
          (keypress)="onKeyPress($event)"
          (paste)="onPaste($event)"
          />
        <label for="username">{{ userContent()?.usernameLabel }}</label>

        @if (username?.invalid && (!username?.untouched || username?.dirty ||
        submitted)) {
        <div class="alert alert-danger">
          @if (username?.hasError('required') ||
          username?.hasError('soloEspacios')) {
          <span>
            {{ userContent()?.usernameError }}
          </span>
          }
        </div>
        }
      </div>
      <!-- Correo electrónico -->
      <div class="input-container">
        <input id="email" type="email" class="form-control" formControlName="email" required
          [ngClass]="{ filled: formUser.get('email')?.value }" />
        <label for="email">{{ userContent()?.emailLabel }}</label>

        @if (email?.invalid && (!email?.untouched || email?.dirty || submitted))
        {
        <div class="alert alert-danger">
          @if (email?.hasError('required') || email?.hasError('email')) {
          <span>{{ userContent()?.emailError }}</span>
          }
        </div>
        }
      </div>
    </div>  

    <div class="form-row full-width">
     <div class="input-container switch-container">
        <div class="switch-simple-wrapper">
          <div class="custom-toggle" [class.active]="isAdminUser" (click)="toggleUserType()">
            <div class="custom-toggle-track">
              <div class="custom-toggle-thumb"></div>
            </div>
          </div>
            <span class="switch-simple-label">El usuario es administrador</span>
        </div>
      </div>
    @if(!isAdminUser){
      <div class="input-container">
        <mat-form-field appearance="outline" class="full-width" floatLabel="always">
          <mat-label>{{ userContent()?.clientLabel }}</mat-label>
          <mat-select formControlName="cliente" [compareWith]="compareClients" placeholder="Seleccione un cliente" required>
            <mat-option *ngIf="isLoadingClients" disabled>
              Cargando clientes...
            </mat-option>
            <mat-option *ngFor="let client of clients" [value]="client">
              {{ client.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="cliente?.invalid && (!cliente?.untouched || cliente?.dirty || submitted)">
            <span *ngIf="cliente?.hasError('required')">{{ userContent()?.clientError }}</span>
          </mat-error>
        </mat-form-field>
      </div>
    }
    </div>

    <!-- @if (id) { -->
    <div class="form-row">
      <!-- Contraseña -->
      <div class="input-container">
        <input id="password" type="password" class="form-control" formControlName="password" required
          [type]="showPassword ? 'text' : 'password'"
          autocomplete="new-password" readonly onfocus="this.removeAttribute('readonly');"
          [ngClass]="{ filled: formUser.get('password')?.value }" (keypress)="onPasswordKeyPress($event)"
          (input)="onPasswordInput($event)" (paste)="onPaste($event)" />
        <label for="password">{{ userContent()?.passwordLabel }}</label>
        <button
          type="button"
          class="toggle-password-btn"
          (click)="togglePasswordVisibility()">
          <mat-icon class="eye-icon">
            {{ showPassword ? 'visibility_off' : 'visibility' }}
          </mat-icon>
        </button>

        @if (formUser.get('password')?.invalid &&
        (!formUser.get('password')?.untouched || formUser.get('password')?.dirty
        || submitted)) {
        <div class="alert alert-danger">
          @if (formUser.get('password')?.hasError('required')) {
          <span> {{ userContent()?.confirmPasswordError }}</span>
          } @if (formUser.get('password')?.hasError('minlength')) {
          <span> {{ userContent()?.passwordMinLengthError }}</span>
          }
        </div>
        }
      </div>
      <!-- Confirmar contraseña -->
      <div class="input-container">
        <input id="confirmPassword" type="password" class="form-control" formControlName="confirmPassword" required
          [type]="showConfirmPassword ? 'text' : 'password'"
          autocomplete="new-password" readonly onfocus="this.removeAttribute('readonly');"
          [ngClass]="{ filled: formUser.get('confirmPassword')?.value }" (input)="onConfirmPasswordInput($event)" />
        <label for="confirmPassword">{{ userContent()?.confirmPasswordLabel }}</label>
        <button
          type="button"
          class="toggle-password-btn"
          (click)="toggleConfirmPasswordVisibility()">
          <mat-icon class="eye-icon">
            {{ showConfirmPassword ? 'visibility_off' : 'visibility' }}
          </mat-icon>
        </button>

        @if (formUser.get('confirmPassword')?.invalid &&
        (!formUser.get('confirmPassword')?.untouched ||
        formUser.get('confirmPassword')?.dirty || submitted)) {
        <div class="alert alert-danger">
          @if (formUser.get('confirmPassword')?.hasError('required')) {
          <span>{{ userContent()?.confirmPasswordError }}</span>
          } @if (formUser.get('confirmPassword')?.hasError('passwordMismatch'))
          {
          <span>{{ userContent()?.passwordMismatchError }}</span>
          }
        </div>
        }
      </div>
    </div>
    <!-- } -->

    <div class="button-container">
      <button type="button" class="btn-cancel" (click)="onCancel()">
        Cancelar
      </button>
      <button type="submit" [disabled]="formUser.invalid" [ngClass]="{
          'btn-disabled': formUser.invalid,
          'btn-enabled': formUser.valid
        }">
        {{ id ? "Actualizar" : "Guardar" }}
      </button>
    </div>
  </form>
</div>